import {createContext} from 'react';
import {Canvas, FabricObject} from 'fabric';
import {Resource} from 'crqlar-react-common/dist/models/resource/resource.model';
import {Service} from 'crqlar-react-common/dist/models/service/service.model';
import {FloorPlanItem} from './types';

interface context {
    mode: "read" | "edit"
    canvas: Canvas | null;
    isInitialized: boolean;
    canvasElRef: React.MutableRefObject<HTMLCanvasElement | null>
    containerRef: React.MutableRefObject<HTMLDivElement | null>
    showSeatsAroundTable: boolean;
    restaurantId: string;
    restaurantName: string;
    restaurantDraft: Resource | null;
    setRestaurantDraft: React.Dispatch<React.SetStateAction<Resource | null>>;
    restaurantServices: Service[];
    setRestaurantServices: React.Dispatch<React.SetStateAction<Service[]>>;
    addedRestaurantServices: Service[];
    setAddedRestaurantServices: React.Dispatch<React.SetStateAction<Service[]>>;
    restaurantServicesLoading: boolean;
    removedRestaurantServiceIds: string[];
    setRemovedRestaurantServiceIds: React.Dispatch<React.SetStateAction<string[]>>;
    refetchRestaurantServices: () => Promise<unknown>;
    updateTableElementLocally: (
        element: FabricObject,
        updater: (item: FloorPlanItem, currentElement: FabricObject) => FloorPlanItem
    ) => FabricObject | null;
    updateAllTableElementsLocally: (
        updater: (item: FloorPlanItem, currentElement: FabricObject) => FloorPlanItem
    ) => FabricObject[];
}

const FloorplanContext = createContext<context | null>(null);


export default FloorplanContext;
